import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdDiarioObrasEfetivo: number;
  IdDiarioObras: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  IdDiarioObrasEfetivo: 0,
  IdDiarioObras: 0,
};

export const useDiarioObrasEfetivoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));